import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-12 text-center" }
const _hoisted_4 = { class: "row mt-4 mb-4" }
const _hoisted_5 = { class: "col-12 text-center" }
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "col-12 text-center" }
const _hoisted_8 = { class: "row" }
const _hoisted_9 = { class: "col-12 text-center h3 text-danger" }
const _hoisted_10 = { class: "h1 text-center fw-bold" }
const _hoisted_11 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _cache[3] || (_cache[3] = _createElementVNode("div", { class: "row" }, [
        _createElementVNode("div", { class: "col-12 mt-4" }, [
          _createElementVNode("h3", null, "Please Enter user name and password to login")
        ])
      ], -1)),
      _cache[4] || (_cache[4] = _createElementVNode("div", { class: "row" }, [
        _createElementVNode("div", { class: "col-12" }, [
          _createElementVNode("h3", null, "(For Existing Users)")
        ])
      ], -1)),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("span", null, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.userName) = $event)),
              placeholder: "Enter Username"
            }, null, 512), [
              [_vModelText, $setup.userName]
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("span", null, [
            _withDirectives(_createElementVNode("input", {
              type: "password",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.password) = $event)),
              placeholder: "Enter Password"
            }, null, 512), [
              [_vModelText, $setup.password]
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("span", null, [
            _createElementVNode("button", {
              class: "btn btn-primary",
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => ($setup.login && $setup.login(...args)))
            }, "Login")
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("span", null, _toDisplayString($setup.loginResult), 1)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_10, [
      ($setup.companyIconFileName && $setup.companyIconFileName !== '')
        ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            src: $setup.companyIconFileName,
            class: "d-inline-block align-text-bottom",
            "border-color": "red",
            width: "65",
            height: "65"
          }, null, 8, _hoisted_11))
        : _createCommentVNode("", true),
      _createTextVNode(" " + _toDisplayString($setup.companyName), 1)
    ])
  ], 64))
}